module.exports = __webpack_public_path__ + "img/swish.6fc58e45.svg";